import { WorkspaceDetails } from "@common/types/workspace";
import {
    GridTable,
    GridTableHeader,
} from "@components/general/Tables/GridTable/GridTable";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import { FC, useState } from "react";
import { useWorkspaces } from "@api/workspace.api";
import { Loader } from "@components/general/Loader";
import { PersonalViewFilters } from "../types";
import styles from "./Workspaces.module.scss";
import { WorkspaceRow } from "./WorkspaceRow";

export const WorkspacesPage: FC = () => {
    const [filters, setFilters] = useState<PersonalViewFilters>({
        search: "",
    });

    const { data: workspaces, isLoading } = useWorkspaces({
        search: filters.search,
        limit: 100,
    });

    if (isLoading) {
        return <Loader />;
    }

    return (
        <>
            <TablePageHeader
                search={filters.search}
                onSearchChange={(val) =>
                    setFilters((currentFilters) => ({
                        ...currentFilters,
                        search: val,
                    }))
                }
                filters={filters}
                onFiltersChange={(newFilters) => {
                    setFilters((currentFilters) => ({
                        ...currentFilters,
                        ...newFilters,
                    }));
                }}
            />
            <section>
                <GridTable className={styles.workspacesTable}>
                    <GridTableHeader className={styles.header}>
                        <div>Workspace</div>
                        <div>Entities</div>
                        <div>Team</div>
                    </GridTableHeader>

                    {(workspaces?.data ?? []).map(
                        (workspaceDetails: WorkspaceDetails) => (
                            <WorkspaceRow
                                key={workspaceDetails.workspace.id}
                                workspace={workspaceDetails}
                            />
                        ),
                    )}
                </GridTable>
            </section>
        </>
    );
};
